import React, { Suspense, useEffect, useState } from 'react';
import { I18nextProvider } from 'react-i18next';

import type { RuntimeConfig } from '../pages/api/config';

import { getI18n } from './config';

interface I18nProviderProps {
  children: React.ReactNode;
  locale?: string;
}

const CONFIG_URL = '/cal/api/config';

export const I18nProvider = ({ children, locale = 'en-GB' }: I18nProviderProps) => {
  const [i18n, setI18n] = useState(() =>
    // On the server or on first client render, initialise without tenantId.
    // It will be re-initialised below once the runtime config is fetched.
    typeof window === 'undefined' ? getI18n(locale) : null,
  );

  useEffect(() => {
    fetch(CONFIG_URL)
      .then<RuntimeConfig>(r => r.json())
      .then(({ locizeTenantId }) => {
        setI18n(getI18n(locale, locizeTenantId || undefined));
      })
      .catch(() => {
        // Fallback: init without tenant ID, will use the default Locize project.
        setI18n(getI18n(locale));
      });
  }, [locale]);

  if (!i18n) return null;

  return (
    <I18nextProvider i18n={i18n}>
      <Suspense fallback={null}>{children}</Suspense>
    </I18nextProvider>
  );
};
